import { toastmsg } from 'Helper';
import axiosApis, { axiosPostJson, axiosGetJson } from 'common/apis/axiosApis';
import axios from "axios";
import { toast } from 'react-toastify';
import Config from "../../config";
import { handleApiFailureResponses } from 'common/handlers/apiHandler';
import axiosDefApis from './axiosDefApis';
import { ROLE_TYPES } from 'bluetail-globals';

const defaultAuthorization = process.env.REACT_APP_default_Authorization
let cancelToken;
let config = new Config()
export async function getNotificationPrivileges(type) {
    const userDetails = JSON.parse(localStorage.getItem("adminDetails"));
    return await axiosApis.get(`/admin/getNotificationPrivileges/${type}`, {
        headers: {
            Authorization: userDetails.token
        }
    })
        .then(async response => {
            await response;
            return response;
        })
        .catch(error => handleApiFailureResponses(error.response));
}

export async function updateNotificationPrivileges(privilegesEmailArray, type) {
    const userDetails = JSON.parse(localStorage.getItem("adminDetails"));

    const payload = {
        roleType: type,
        emailPrivileges: privilegesEmailArray
    }
    return await axiosDefApis.put('/admin/updateNotificationPrivileges', payload, {
        headers: {
            Authorization: userDetails.token
        }
    })
        .then(async response => {
            await response;
            return response;
        })
        .catch(error => handleApiFailureResponses(error.response));
}

export async function getAllCompanyDetails() {
    const userDetails = JSON.parse(localStorage.getItem("adminDetails"));

    return await axiosApis.get('/admin/getAllCompanyDetails', {
        headers: {
            Authorization: userDetails.token
        }
    })
        .then(async response => {
            await response;
            return response;
        })
        .catch(console.error);
}

export async function resetPasswordFromSuperAdmin(password, confirmpassword, email, user_id) {
    const userDetails = JSON.parse(localStorage.getItem("adminDetails"));

    // Passwords must be encoded: a raw & or % would split or mangle the form body (BT-9903).
    let payload = `password=${encodeURIComponent(password)}&confirmPassword=${encodeURIComponent(confirmpassword)}&email=${email}&user_id=${user_id}`;
    return await axiosApis.post('/admin/resetPasswordFromSuperAdmin', payload, {
        headers: {
            Authorization: userDetails.token
        }
    })
        .then(async response => {
            await response;
            return response;
        })
        .catch(error => handleApiFailureResponses(error.response));
}

export async function blockUsersBySuperAdmin(user_id, blockStatus, role, admin_user) {
    const userDetails = JSON.parse(localStorage.getItem("adminDetails"));

    let payload = `user_id=${user_id}&blockStatus=${blockStatus}&role=${role}&admin_user=${admin_user}`;
    return await axiosApis.post('/admin/blockUsersBySuperAdmin', payload, {
        headers: {
            Authorization: userDetails.token
        }
    })
        .then(async response => {
            await response;
            return response.data;
        })
        .catch(console.error);
}

export async function archiveUsersBySuperAdmin(user_id, email) {
    const userDetails = JSON.parse(localStorage.getItem("adminDetails"));

    let payload = `user_id=${user_id}&email=${email}`;
    return await axiosApis.post('/admin/archiveUsersBySuperAdmin', payload, {
        headers: {
            Authorization: userDetails.token
        }
    })
        .then(async response => {
            await response;
            return response;
        })
        .catch((error) => handleApiFailureResponses(error.response));
}

// Superadmin system-wide Users list (BT-9797). `roleId` may be '' / null for "any role".
// A `max` of 0 asks the backend for every matching row (used by the CSV export).
export async function getAllSystemUsers(min, max, searchText, roleId) {
    const userDetails = JSON.parse(localStorage.getItem("adminDetails"));

    const params = new URLSearchParams({ min, max, search_text: searchText ?? '' });
    if (roleId !== '' && roleId != null) {
        params.set('role_id', String(roleId));
    }

    return await axiosApis.get(`/admin/getAllSystemUsers?${params.toString()}`, {
        headers: {
            Authorization: userDetails.token
        }
    })
        .then(async response => {
            await response;
            return response;
        })
        .catch(console.error);
}

// Superadmin system-wide Aircraft list (BT-9798). `status` may be '' / null for "any status"
// (0=Provisional, 1=Active, 2=Deactive). A `max` of 0 asks the backend for every matching row
// (used by the CSV export).
export async function getAllSystemAircraft(min, max, searchText, status, companyId) {
    const userDetails = JSON.parse(localStorage.getItem("adminDetails"));

    const params = new URLSearchParams({ min, max, search_text: searchText ?? '' });
    if (status !== '' && status != null) {
        params.set('status', String(status));
    }
    if (companyId !== '' && companyId != null) {
        params.set('company_id', String(companyId));
    }

    return await axiosApis.get(`/admin/getAllSystemAircraft?${params.toString()}`, {
        headers: {
            Authorization: userDetails.token
        }
    })
        .then(async response => {
            await response;
            return response;
        })
        .catch(console.error);
}

export async function getAccountsAndUsersType(type, min, max, searechText) {
    const userDetails = JSON.parse(localStorage.getItem("adminDetails"));

    let payload = `type=${type}&min=${min}&max=${max}&search_text=${encodeURIComponent(searechText)}`;

    return await axiosApis.get(`/admin/getAccountsAndUsersType?${payload}`, {
        headers: {
            Authorization: userDetails.token
        }
    })
        .then(async response => {
            await response;
            return response;
        })
        .catch(console.error);
}

export async function getAllCompanies() {

    const queryArgs = {
    };
    return axiosGetJson('/admin/getAllCompanyDetails', queryArgs);

}

export async function getAllActivePlanes() {
    const userDetails = JSON.parse(localStorage.getItem("adminDetails"));

    return await axiosApis.get('/admin/getAllActivePlanes', {
        headers: {
            Authorization: userDetails.token
        }
    })
        .then(async response => {
            await response;
            return response;
        })
        .catch(console.error);
}

export async function getAllUsersData(company_id, min, max, search_text = '') {
    const userDetails = JSON.parse(localStorage.getItem("adminDetails"));

    return await axiosApis.get(`/admin/getAllUsers?min=${min}&max=${max}&company_id=${company_id}&search_text=${encodeURIComponent(search_text)}`, {
        headers: {
            Authorization: userDetails.token
        }
    })
        .then(async response => {
            await response;
            return response.data.data;
        })
        .catch(console.error);
}

export async function getAircrafts(company_id, min, max, search_text) {
    const userDetails = JSON.parse(localStorage.getItem("adminDetails"));

    return await axiosApis.get(`/admin/getAllAircrafts/${company_id}?min=${min}&max=${max}&search_text=${encodeURIComponent(search_text)}`, {
        headers: {
            Authorization: userDetails.token,
        }
    })
        .then(async response => {
            await response;
            return response;
        })
        .catch((error) => handleApiFailureResponses(error.response));
}

export async function getAllFeaturesList(company_id) {
    // The Features tab shows all features in one view (no paging, no server-side search). BT-9737.
    return axiosGetJson('/admin/getAllFeaturesList', { company_id });
}

export async function updateAccountFeatures(company_id, feature_enabled, feature_id) {

    const payload = {
        company_id,
        feature_enabled,
        feature_id
    };

    return axiosPostJson('/admin/updateAccountFeatures', payload);
}

export async function makeAircraftProvisional(status, reg_n_number, company_id) {

    let payload = {
        company_id,
        provisional_status: status,
        reg_n_number,
    };

    return axiosPostJson('/admin/makeAircraftProvisional', payload);
}

export async function getFleets(min, max, search_text, current_user_id, company_id) {
    const userDetails = JSON.parse(localStorage.getItem("adminDetails"));

    return await axiosApis.get(`/getAllFleets/${company_id}?min=${min}&max=${max}&search_text=${encodeURIComponent(search_text)}&current_user_id=${current_user_id}`, {
        headers: {
            Authorization: userDetails.token,
        }
    })
        .then(async response => {
            await response;
            return response;
        })
        .catch((error) => handleApiFailureResponses(error.response));
}

export async function getRoles() {
    const userDetails = JSON.parse(localStorage.getItem("adminDetails"));

    return await axiosApis.get('/getAllRoles', {
        headers: {
            Authorization: userDetails.token
        }
    })
        .then(async response => {
            await response;
            if (response.data.data.roles) {
                // Only list known roles: until BT-10801's migration runs everywhere, role_types still has the retired Guest (5).
                const knownRoleIds = Object.values(ROLE_TYPES);
                response.data.data.roles = response.data.data.roles.filter((role) => knownRoleIds.includes(role.role_id))
            }
            return response;
        })
        .catch(console.error);
}

export async function getAllUserGroups() {
    const userDetails = JSON.parse(localStorage.getItem("adminDetails"));

    return await axiosApis.get('/admin/getAllUserGroups', {
        headers: {
            Authorization: userDetails.token
        }
    })
        .then(async response => {
            await response;
            return response;
        })
        .catch(console.error);
}

export async function getAllRelatedDocuments(combine_files) {
    const userDetails = JSON.parse(localStorage.getItem('userDetails'))?.state?.userData || {};

    try {
        return await axios({
            method: "get",
            url: `${config.BASEURL}/app/getAllRelatedDocuments?combine_files=${combine_files}`,
            headers: {
                "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
                Authorization: userDetails.session.token
            },
        })
            .then(async response => {
                await response;
                return response;
            })
            .catch(error => {
                console.error("Error:", error.response.data.message)
                toastmsg(error.response.data.message, toast.POSITION.TOP_CENTER, 3000);
                return error.response;
            });
    } catch (error) {
        toastmsg(error, toast.POSITION.TOP_CENTER, 3000);
    }
}

export async function getAllATACodes() {
    const userDetails = JSON.parse(localStorage.getItem('adminDetails'));

    return await axiosApis.get(`/getAllATACodes`, {
        headers: {
            Authorization: userDetails.token,
        }
    })
        .then(async response => {
            await response;
            return response;
        })
        .catch((error) => handleApiFailureResponses(error.response));
}

export async function getAdminProfile() {
    const userDetails = JSON.parse(localStorage.getItem('adminDetails'));

    return await axiosApis.get(`/admin/getAdminProfile/${userDetails.admin_id}`, {
        headers: {
            Authorization: userDetails.token,
        }
    })
        .then(async response => {
            await response;
            return response;
        })
        .catch((error) => console.log(error, 'error'));
}

export async function getAllPrivileges(type) {
    const userDetails = JSON.parse(localStorage.getItem("adminDetails"));
    return await axiosApis.get(`/admin/getAllPrivileges?roleType=${type}`, {
        headers: {
            Authorization: userDetails.token
        }
    })
        .then(async response => {
            await response;
            return response;
        })
        .catch((error) => handleApiFailureResponses(error.response));
}

export async function updatePrivileges(privilegesArray, type) {
    // DEPRECATED. We no longer support dynamic soft configuration of roles via the admin panel.
}

